import * as React from "react"


const LetMeKnowPage = () => {
    return(
        <main>
            <title>hello there.</title>
            <div className="md:container md:mx-auto dark:text-white text-center">
                <h1 className="text-3xl md:text-6xl px-2 md:px-0">hello there</h1>
                <p className="pt-6">As an adult human with responsibilities, I am occasionally unable to watch games when EG plays. As such, I rely on the good people of the internet to let me know so I can update the site. Thank you for doing this!</p>
                <br/>
                <p>However, sometimes, there are people out there that (perish the thought!) enjoy watching EG lose and tell me to update the site when EG drop the most minor of networth leads.</p>
                <br/>
                <p>With that in mind, it'd be much appreciated if you could give me a win probability graph or a Twitch clip when you let me know. Thanks!</p>
                <br/>

                <p>Update: Ooops, Twitter is kind of dying and I don't go on it that much anymore... erm, if you're on <a className="underline" href="https://bsky.app/profile/videogamesarebad.co.uk">Bluesky</a> you can reach out I guess? Or... <a className="underline" href="https://github.com/hnegus1/eg_throw_further/issues">make a GitHub issue maybe?</a></p>
            </div>
        </main>
    )
}

export default LetMeKnowPage